<template>
	<div class="upload-youtube">
		<Title :title="'上傳Youtube'"></Title>
		<SearchBar :searchText="searchText" @search="handleSearch" placeholder="故事名稱、小組名稱、故事帳號、輔導員"></SearchBar>
		<div class="filter">
			<el-radio-group v-model="status" @change="handleStatusChange">
				<el-radio-button label="全部"></el-radio-button>
				<el-radio-button label="已完成"></el-radio-button>
				<el-radio-button label="待審核"></el-radio-button>
				<el-radio-button label="未完成"></el-radio-button>
			</el-radio-group>
		</div>
		<el-pagination class="layout-row layout-justify-center" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 30, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="storyList.total">
		</el-pagination>
		<div class="layout-row save-btn-box">
			<el-button class="save-btn" type="primary" @click="save">儲存</el-button>
		</div>
		<el-table :data="storyList.list" style="width: 100%">
			<el-table-column prop="account" label="故事帳號" sortable width="160">
			</el-table-column>
			<el-table-column label="Youtube分享網址">
				<template slot-scope="{row}">
					<el-input v-model="row.youtubeURL" placeholder="Youbute分享網址"></el-input>
				</template>
			</el-table-column>
		</el-table>
		<div class="layout-row save-btn-box">
			<el-button class="save-btn" type="primary" @click="save">儲存</el-button>
		</div>
		<el-pagination class="layout-row layout-justify-center" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 30, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="storyList.total">
		</el-pagination>
	</div>
</template>

<script>
import Title from "@/components/backendManage/Title";
import SearchBar from "@/components/backendManage/SearchBar";
import { mapActions, mapState } from "vuex";

export default {
	data() {
		return {
			status: "全部",
			currentPage: 1,
			pageSize: 10,
			searchText: ""
		};
	},
	computed: {
		...mapState("story", ["storyList"]),
		query() {
			return {
				page: this.currentPage,
				size: this.pageSize,
				status: this.status,
				text: this.searchText
			};
		}
	},
	methods: {
		...mapActions("story", ["searchBackendAllStories", "uploadYoutbe"]),
		replaceRouter() {
			this.$router.replace({
				query: this.query
			});
		},
		handleSizeChange(value) {
			this.pageSize = value;
			this.replaceRouter();
			this.searchStories();
		},
		handleStatusChange() {
			this.replaceRouter();
			this.searchStories();
		},
		handleCurrentChange(value) {
			this.currentPage = value;
			this.replaceRouter();
			this.searchStories();
		},
		handleSearch(searchText) {
			this.searchText = searchText;
			this.replaceRouter();
			this.searchStories();
		},
		searchStories() {
			this.searchBackendAllStories(this.query);
		},
		async save() {
			let data = [];
			for (let story of this.storyList.list) {
				if (story.youtubeURL) {
					data.push({
						id: story.id,
						url: story.youtubeURL
					});
				}
			}

			if (data.length > 0) {
				try {
					await this.uploadYoutbe(data);
					this.$message.success("上傳成功");
				} catch (e) {
					this.$message.error(e.message);
				}
			}
		},
		init() {
			let query = this.$route.query;
			this.currentPage = Number(query.page) || 1;
			this.pageSize = Number(query.size) || 10;
			this.status = query.status || "全部";
			this.searchText = query.text || "";
			this.searchStories();
		}
	},
	created() {
		this.init();
	},
	mounted() { },
	components: {
		Title,
		SearchBar
	}
};
</script>

<style lang="scss" scoped>
.el-pagination {
	margin-top: 15px;
}
.filter {
	margin-left: 25px;
}

.save-btn-box {
	justify-content: flex-end;

	.save-btn {
		margin: 10px 50px 0 0;
	}
}
</style>